import BaseModelAPI from '../BaseModelAPI';

export default class PurchaseOrderDetail extends BaseModelAPI {
	static entity = 'purchaseorderdetail';
	static entityName = 'purchaseorderdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partId = '';
			this.part = {};
			this.purchaseOrderId = '';
			this.purchaseOrder = {};
			this.partName = '';
			this.qtyPo = 0;
			this.uom = '';
			this.priceUnit = 0;
			this.subtotal = 0;
			this.pricePpn = 0;
			this.amount = 0;
			this.qtyOutstanding = 0;
			this.percentagePpn = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}